import React from "react";
import { PopupButton } from "@typeform/embed-react";

import { useEventTracker } from "hooks/useEventTracker";
import { Action, Category } from "utils/trackEvent";

export default function Typeform({ surveyId }: { surveyId: string }) {
  const { publishEvent } = useEventTracker();

  return (
    <div className="text-center text-white bg-black text-xs py-sm">
      <PopupButton
        id={surveyId}
        autoClose={3}
        shareGaInstance={true}
        onSubmit={() => {
          publishEvent({
            action: Action.click,
            category: Category.feedbackSurvey,
            label: "feedback submitted",
          });
        }}
        onReady={() => {
          publishEvent({
            action: Action.click,
            category: Category.feedbackSurvey,
            label: "open survey",
          });
        }}
      >
        Website feedback? Let Leafly know.
      </PopupButton>
      <style jsx>
        {`
          .tf-v1-widget {
            z-index: 99999 !important;
          }
        `}
      </style>
    </div>
  );
}
